// extracted by mini-css-extract-plugin
export default {"container":"Login_container__UnOzY","imgWrapper":"Login_imgWrapper__fXUsE","formWrapper":"Login_formWrapper__GDy7S","formTitle":"Login_formTitle__VJkRq"};